/* eslint-disable no-var */
// Hold the Yard scene renderer, ported from design/hold-the-yard/scene-reference.html.
// The sprite maps, palette and scene definitions below are copied verbatim from
// that file; only renderScene() changed, to use inline styles instead of the
// reference page's classes. Output is a 600x400 HTML fragment.

var PALETTE = {
  brown: '#6B3320', wall: '#3A4755', door: '#5A6878', slate: '#2B3640', steel: '#4A5866',
  deep: '#A8431C', ink: '#0B0F14', khaki: '#D9CBB0', orange: '#E8622C', amberDark: '#C98A1F',
  amber: '#F2B134', purpleDark: '#6A45A8', purple: '#B58CFF', cream: '#F4EBDD'
};
var LAYER_ORDER = ['brown','wall','door','slate','steel','deep','ink','khaki','orange','amberDark','amber','purpleDark','purple','cream'];

var BARN = ['.......OO.......','......OOOO......','.....OOOOOO.....','....OOOOOOOO....','...OOOOOOOOOO...','..OOOOOOOOOOOO..','.OOOOOOOOOOOOOO.','OOOOOOOOOOOOOOOO','.SSSSSSSSSSSSSS.','.SSCCCCCCCCCCSS.','.SSCSCCSSCCSCSS.','.SSCCSCSSCSCCSS.','.SSCCCSSSSCCCSS.','.SSCCSCSSCSCCSS.','.SSCSCCSSCCSCSS.','.SSCCCCCCCCCCSS.'];
var SPRITES = {
  tractor: { m: ['.....SS.......','....SSSS......','....SGGS......','....SGGS......','.OOOOOOOOOOO..','.OOOOOOOOOOOOY','OOOOOOOOOOOOO.','.WWWWW....WW..','WWSSSWW..WSSW.','WWSSSWW..WSSW.','.WWWWW....WW..'], c: { O: 'orange', S: 'steel', G: 'amber', W: 'ink', Y: 'cream' } },
  barn: { m: BARN, c: { O: 'deep', S: 'wall', C: 'door' } },
  barnNew: { m: BARN, c: { O: 'orange', S: 'wall', C: 'door' } },
  barnHit: { m: ['.......OO.......','......OKKO......','.....OOK.OO.....','....OOOOOOOO....','...OOOKOOOOOO...','..OOOOOOOOKKOO..','.OOOOOOOOOOK.OO.','OOOOOOOOOOOOOOOO','.SSSSSSSSSSSSSS.','.SSCCCCCCCCCCSS.','.SSCSCCSSCCKKSS.','.SSCCSCSSCKCCSS.','.SSCCCSSSSCKCSS.','.SSCCSCSSCKCCSS.','.SSCSCCSSKCCKSS.','.SSCCCCCCCCCCSS.'], c: { O: 'deep', S: 'wall', C: 'door', K: 'ink' } },
  rust: { m: ['...RRRRR...','.RROOOOORR.','RROCCOCCORR','ROOCKOCKOOR','ROOOOOOOOOR','.ROORRROOR.','R.RR...RR.R','.R.......R.'], c: { R: 'deep', O: 'orange', C: 'cream', K: 'ink' } },
  tyre: { m: ['..KKKKKKK..','.KSKSKSKSK.','KSKKKKKKKSK','KKAAKKKAAKK','KSKAKKKAKSK','KKKKKKKKKKK','.KSKSKSKSK.','.K.K...K.K.'], c: { K: 'ink', S: 'steel', A: 'amber' } },
  drip: { m: ['.....A.....','....AAA....','...AAAAA...','..AACAAAA..','.AAKAAAKAA.','.AAAAAAAAA.','..AOOOOOA..','...AAAAA...','..A..A..A..'], c: { A: 'amber', O: 'amberDark', C: 'cream', K: 'ink' } },
  belt: { m: ['CCC.........','CKCC....CCC.','.CCCC..CCCCC','...CCCDCC..C','....CCDC....'], c: { C: 'khaki', D: 'brown', K: 'ink' } },
  clock: { m: ['.O.......O.','..OOOOOOO..','.OCCCSCCCO.','OCCCCSCCCCO','OCCCCSSSCCO','OCCCCCCCCCO','.OCCCCCCCO.','..OOOOOOO..','.O.......O.'], c: { O: 'orange', C: 'cream', S: 'slate' } },
  boom: { m: ['A..A..A','.A.O.A.','..OCO..','AOC.COA','..OCO..','.A.O.A.','A..A..A'], c: { A: 'amber', O: 'orange', C: 'cream' } },
  firework: { m: ['....A....','.C..A..C.','..C.O.C..','...OOO...','AAOOCOOAA','...OOO...','..C.O.C..','.C..A..C.','....A....'], c: { A: 'amber', O: 'orange', C: 'cream' } },
  smoke: { m: ['.SS..','SSSS.','.SSSS','..SS.'], c: { S: 'steel' } },
  fire: { m: ['..A..','.AOA.','AOOOA','.OOO.'], c: { A: 'amber', O: 'orange' } },
  shot: { m: ['A','O','O'], c: { A: 'amber', O: 'orange' } },
  flag: { m: ['CPPP','CPPP','CPP.','C...','C...'], c: { C: 'cream', P: 'purple' } },
  arrow: { m: ['.....P.....','....PPP....','...PPPPP...','..PPPPPPP..','.PPPPPPPPP.','PPPPPPPPPPP','...PPPPP...','...PPPPP...','...PPPPP...','...PPPPP...','...DDDDD...'], c: { P: 'purple', D: 'purpleDark' } },
  trophy: { m: ['.AAAAAAAAAA.','AAACAAAAAAOA','A.ACAAAAAO.A','A.AAAAAAAO.A','.AAAAAAAAOA.','..AAAAAAOO..','...AAAAOO...','.....AO.....','.....AO.....','....AAOO....','...AAAAOO...','...OOOOOO...'], c: { A: 'amber', O: 'amberDark', C: 'cream' } }
};

var STARS = 'M8 6h1v1h-1zM27 9h1v1h-1zM49 4h1v1h-1zM71 8h1v1h-1zM96 5h1v1h-1zM118 9h1v1h-1zM141 4h1v1h-1zM37 22h1v1h-1zM104 21h1v1h-1zM146 16h1v1h-1zM14 26h1v1h-1z';
var EXTRA_STARS = 'M3 14h1v1h-1zM19 31h1v1h-1zM57 12h1v1h-1zM84 6h1v1h-1zM92 34h1v1h-1zM110 18h1v1h-1zM136 38h1v1h-1zM44 38h1v1h-1z';
var FLEET = [['tractor', 34, 75], ['tractor', 66, 75], ['tractor', 98, 75]];
var SPECIAL_HZ = ['#2E1F45', '#5E3F96'];

var SCENES = {
  overrun: { name: 'Base overrun', title: 'BASE OVERRUN', size: 32, color: '#E0412F', level: 1, hz: ['#5A1A16', '#B8322A'], sub: 'THE YARD FELL · NEXT WAVE STARTS MONDAY',
    items: [['barnHit', 4, 70]].concat(FLEET, [['rust',6,12],['tyre',24,11],['clock',42,12],['rust',60,11],['drip',78,12],['tyre',96,11],['rust',114,12],['clock',132,11],['drip',14,26],['belt',34,28],['rust',52,25],['tyre',72,26],['clock',92,25],['drip',112,26],['belt',130,29],['belt',22,81],['rust',52,78],['tyre',84,78],['clock',116,77],['fire',10,66],['smoke',8,61],['smoke',13,57],['smoke',37,70],['shot',103,70]]) },
  underAttack: { name: 'Under attack', title: 'UNDER ATTACK', size: 32, color: '#EE7A2A', level: 2, hz: ['#6B3320', '#A8431C'], sub: 'TOO MANY GOT THROUGH THIS WEEK',
    items: [['barn', 4, 70]].concat(FLEET, [['tyre',6,11],['rust',24,12],['clock',42,11],['drip',60,11],['rust',78,12],['tyre',96,11],['clock',114,11],['rust',132,12],['belt',10,27],['drip',30,25],['tyre',50,26],['clock',70,25],['belt',90,28],['rust',110,26],['drip',130,25],['rust',52,78],['boom',128,40],['boom',16,44],['shot',39,68],['shot',71,66],['shot',103,70]]) },
  holding: { name: 'Holding the line', title: 'HOLDING THE LINE', size: 26, color: '#F2C12E', level: 3, hz: ['#5A4716', '#A8841F'], sub: 'MOST SHOT DOWN · A FEW SLIPPED PAST',
    items: [['barn', 4, 70]].concat(FLEET, [['rust',12,12],['tyre',40,18],['drip',64,12],['clock',100,28],['belt',118,18],['rust',132,10],['tyre',8,56],['clock',130,50],['boom',82,20],['boom',28,28],['shot',39,62],['shot',71,60],['shot',103,64]]) },
  defended: { name: 'Defended', title: 'DEFENDED', size: 40, color: '#6CC47A', level: 4, hz: ['#1E4430', '#3C7F52'], sub: 'WAVE CLEARED · ONE NEAR MISS',
    rects: [[82,24,2,1],[98,24,2,1],[82,38,2,1],[98,38,2,1],[90,20,1,2],[90,40,1,2],[78,31,2,1],[101,31,2,1]],
    items: [['barn', 4, 70]].concat(FLEET, [['rust',20,14],['tyre',56,26],['belt',6,35],['drip',85,27],['clock',126,61],['boom',42,15],['boom',112,14],['boom',134,30],['shot',39,65],['shot',71,63],['shot',103,67]]) },
  perfect: { name: 'Perfect wave', title: 'PERFECT WAVE', size: 32, color: '#58C4DD', level: 5, hz: ['#1A4450', '#2F8499'], sub: 'EVERY CHECK ON TIME · NOT ONE GOT THROUGH', extraStars: EXTRA_STARS + 'M63 36h1v1h-1zM124 29h1v1h-1z',
    items: [['barn', 4, 70]].concat(FLEET, [['firework',10,12],['firework',64,16],['firework',124,10],['firework',36,26],['firework',100,26]]) },
  comeback: { name: 'Comeback', title: 'COMEBACK', size: 40, color: '#B58CFF', level: 4, hz: SPECIAL_HZ, sub: 'FROM OVERRUN TO DEFENDED · THE YARD IS BACK',
    items: [['barnNew', 4, 70], ['flag', 12, 65]].concat(FLEET, [['rust',-5,10],['tyre',144,12],['belt',60,4],['boom',22,16],['boom',44,26],['boom',96,18],['boom',118,28],['firework',70,20],['shot',39,62],['shot',71,60],['shot',103,62]]) },
  mostImproved: { name: 'Most improved', title: 'MOST IMPROVED', size: 30, color: '#B58CFF', level: 4, hz: SPECIAL_HZ, sub: 'UP TWO STATES ON YOUR MONTHLY AVERAGE',
    items: [['barn', 4, 70]].concat(FLEET, [['arrow',69,14],['rust',18,14],['clock',124,16],['boom',40,22],['boom',100,12],['boom',132,34],['shot',39,64],['shot',71,62],['shot',103,66]]) },
  climbing: { name: 'Climbing', title: 'CLIMBING', size: 40, color: '#B58CFF', level: 3, hz: SPECIAL_HZ, sub: 'THREE WEEKS BETTER IN A ROW',
    rects: [[60,32,6,6,'purpleDark'],[68,26,6,12,'purple'],[76,18,6,20,'purple'],[76,18,6,1,'cream']],
    items: [['barn', 4, 70]].concat(FLEET, [['tyre',14,14],['drip',118,12],['belt',132,30],['boom',36,24],['boom',98,26],['shot',39,62],['shot',71,60],['shot',103,64]]) },
  perfectStreak: { name: 'Perfect streak', title: 'PERFECT STREAK', size: 28, color: '#B58CFF', level: 5, hz: SPECIAL_HZ, sub: 'ANOTHER FLAWLESS WAVE · THE STREAK GROWS', extraStars: EXTRA_STARS,
    items: [['barn', 4, 70], ['flag', 12, 65]].concat(FLEET, [['trophy',69,16],['firework',12,12],['firework',126,10],['firework',38,28],['firework',104,28]]) }
};

// ---------- animation ----------
// FRAMES frames at FRAME_MS each form one seamless loop. Frame 0 is close to the
// static reference; every effect below is periodic in FRAMES.
export var FRAMES = 24;
export var FRAME_MS = 125;

var INVADERS = { rust: 1, tyre: 1, drip: 1, belt: 1, clock: 1 };
var MARCH = [0, 1, 2, 1, 0, -1, -2, -1]; // one step every 3 frames

// Keep only some of a sprite's pixels (used for firework bursts).
function maskSprite(sp, keep) {
  return { c: sp.c, m: sp.m.map(function (row, y) {
    return row.split('').map(function (ch, x) { return ch !== '.' && keep(x, y, ch) ? ch : '.'; }).join('');
  }) };
}

// Where (and whether) each placed sprite appears on frame f.
function placeItem(it, idx, f, key) {
  var name = it[0], x = it[1], y = it[2], sp = SPRITES[name];
  if (INVADERS[name]) {
    var step = Math.floor(f / 3) % MARCH.length;
    return { sp: sp, x: x + MARCH[step], y: y + (step % 2) };
  }
  if (name === 'shot') {
    return { sp: sp, x: x, y: y - (f % 12) };
  }
  if (name === 'boom') {
    return ((f + idx * 5) % 12) < 7 ? { sp: sp, x: x, y: y } : null;
  }
  if (name === 'fire') {
    var flip = Math.floor(f / 2) % 2;
    return { sp: flip ? { c: sp.c, m: sp.m.map(function (r) { return r.split('').reverse().join(''); }) } : sp, x: x, y: y - (flip ? 0 : 1) };
  }
  if (name === 'smoke') {
    var rise = Math.floor(((f + idx * 8) % 24) / 4);
    return rise > 4 ? null : { sp: sp, x: x + (rise > 2 ? 1 : 0), y: y - rise };
  }
  if (name === 'firework') {
    var p = (f + idx * 7) % 24;
    if (p < 3 || p >= 19) return null;
    if (p < 6) return { sp: maskSprite(sp, function (px, py) { return Math.abs(px - 4) <= 1 && Math.abs(py - 4) <= 1; }), x: x, y: y };
    if (p < 14) return { sp: sp, x: x, y: y };
    return { sp: maskSprite(sp, function (px, py, ch) { return ch === 'A' || ch === 'C'; }), x: x, y: y };
  }
  if (name === 'arrow' || name === 'trophy') {
    return { sp: sp, x: x, y: y - (Math.floor(f / 4) % 2) };
  }
  return { sp: sp, x: x, y: y };
}

function buildLayers(scene, f, key) {
  var L = {};
  LAYER_ORDER.forEach(function (k) { L[k] = ''; });
  scene.items.forEach(function (it, idx) {
    var pl = placeItem(it, idx, f, key);
    if (!pl) return;
    var sp = pl.sp, ox = pl.x, oy = pl.y;
    for (var y = 0; y < sp.m.length; y++) {
      var row = sp.m[y], x = 0;
      while (x < row.length) {
        var ch = row[x];
        if (ch === '.') { x++; continue; }
        var s = x;
        while (x < row.length && row[x] === ch) x++;
        L[sp.c[ch]] += 'M' + (ox + s) + ' ' + (oy + y) + 'h' + (x - s) + 'v1h-' + (x - s) + 'z';
      }
    }
  });
  (scene.rects || []).forEach(function (r, i) {
    var rx = r[0], ry = r[1], rw = r[2], rh = r[3];
    if (key === 'climbing') {
      // Bars 0-2 grow from their base in turn, then hold; rect 3 is the cap on bar 2.
      var grown = function (b) { return Math.min(1, Math.max(0, (f - b * 3) / 9)); };
      var bar = i === 3 ? scene.rects[2] : r;
      var h = Math.round(bar[3] * grown(i === 3 ? 2 : i));
      if (!h) return;
      ry = bar[1] + bar[3] - h;
      if (i !== 3) rh = h;
    } else if (key === 'defended' && (f % 6) >= 3) {
      return; // targeting sparkle blinks
    }
    L[r[4] || 'amber'] += 'M' + rx + ' ' + ry + 'h' + rw + 'v' + rh + 'h-' + rw + 'z';
  });
  return L;
}

var FONT = "'Press Start 2P', 'Courier New', monospace";

// Split the star field so half the stars twinkle.
function starPaths(d) {
  var parts = d.match(/M[^M]+/g) || [];
  return [parts.filter(function (_, i) { return i % 2 === 0; }).join(''), parts.filter(function (_, i) { return i % 2 === 1; }).join('')];
}

export function renderScene(key, frame) {
  var f = ((frame || 0) % FRAMES + FRAMES) % FRAMES;
  var st = SCENES[key] || SCENES.holding, L = buildLayers(st, f, key);
  var stars = starPaths(STARS + (st.extraStars || ''));
  var twinkle = Math.floor(f / 6) % 2;
  var svg = '<svg viewBox="0 0 150 100" width="600" height="400" aria-hidden="true" style="position:absolute;left:0;top:0;display:block;shape-rendering:crispEdges">' +
    '<rect x="0" y="0" width="150" height="44" fill="#141B24"/>' +
    '<rect x="0" y="44" width="150" height="14" fill="#19222D"/>' +
    '<rect x="0" y="58" width="150" height="10" fill="#202B37"/>' +
    '<rect x="0" y="68" width="150" height="6" fill="#2B3640"/>' +
    '<rect x="0" y="74" width="150" height="3" fill="' + st.hz[0] + '"/>' +
    '<rect x="0" y="77" width="150" height="2" fill="' + st.hz[1] + '"/>' +
    '<path d="' + stars[0] + '" fill="#F4EBDD" opacity="0.55"/>' +
    '<path d="' + stars[1] + '" fill="#F4EBDD" opacity="' + (twinkle ? '0.2' : '0.55') + '"/>' +
    '<path d="M0 80h10v-2h12v-3h14v2h10v-4h16v3h12v-2h18v4h14v-3h14v2h20V86H0z" fill="#0F151C"/>' +
    '<rect x="0" y="86" width="150" height="14" fill="#1E2833"/>' +
    '<rect x="0" y="86" width="150" height="1" fill="#4A5866"/>' +
    '<path d="M6 90h2v1h-2zM22 94h3v1h-3zM41 91h2v1h-2zM58 96h2v1h-2zM77 92h3v1h-3zM95 95h2v1h-2zM112 90h2v1h-2zM130 93h3v1h-3zM145 97h2v1h-2z" fill="#2B3640"/>';
  LAYER_ORDER.forEach(function (k) { if (L[k]) svg += '<path d="' + L[k] + '" fill="' + PALETTE[k] + '"/>'; });
  svg += '</svg>';
  var pips = '';
  for (var i = 1; i <= 5; i++) {
    // The highest lit pip blinks.
    var lit = i < st.level || (i === st.level && (f % 8) < 5);
    pips += '<div style="width:10px;height:10px;box-sizing:border-box;border:2px solid ' + (i <= st.level ? st.color : '#4A5866') + ';' + (lit ? 'background:' + st.color : '') + '"></div>';
  }
  // Base overrun's title flashes; the others stay steady.
  var titleVisible = key !== 'overrun' || (f % 8) < 6;
  return '<div style="width:600px;height:400px;position:relative;overflow:hidden;background:#141B24;font-family:' + FONT + ';color:#F4EBDD">' + svg +
    '<div style="position:absolute;left:0;top:0;width:600px;box-sizing:border-box;padding:14px 16px;display:flex;justify-content:space-between;align-items:center;font-size:10px;letter-spacing:1px"><span>HOLD THE YARD</span><div style="display:flex;gap:4px" aria-label="State ' + st.level + ' of 5">' + pips + '</div></div>' +
    '<div style="position:absolute;left:0;top:168px;width:600px;display:flex;flex-direction:column;align-items:center;gap:16px;text-align:center">' +
    '<div style="line-height:1;text-shadow:4px 4px 0 #0B0F14;font-size:' + st.size + 'px;color:' + st.color + ';visibility:' + (titleVisible ? 'visible' : 'hidden') + '">' + st.title + '</div>' +
    '<div style="font-size:10px;line-height:1.6;text-shadow:2px 2px 0 #0B0F14">' + st.sub + '</div></div>' +
    '<div style="position:absolute;left:0;bottom:0;width:600px;box-sizing:border-box;padding:0 16px 12px;display:flex;justify-content:space-between;font-size:8px;letter-spacing:1px"><span style="color:#E8622C">AGRIWARE</span><span style="color:#B8B0A2">WEEKLY REPORT</span></div></div>';
}

export const SCENE_STATES = Object.keys(SCENES);
export const sceneMeta = (key) => {
  var st = SCENES[key];
  return st ? { name: st.name, color: st.color, level: st.level } : null;
};
